import { useEffect, useRef, useState } from 'react';
import { useFetch } from '../store/app';
import { Icon } from '../components/Icon';
import { st } from '../lib/status';
import type { ActivityEntry } from '../../shared/types';

export function NotificationsBell() {
  const [open, setOpen] = useState(false);
  const { data } = useFetch<ActivityEntry[]>('/activity');
  const items = data || [];
  const box = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onDoc = (e: MouseEvent) => { if (box.current && !box.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  return (
    <div ref={box} style={{ position: 'relative' }}>
      <button title="Notifications" onClick={() => setOpen((o) => !o)} className="cc-hover-s2" style={{ appearance: 'none', border: '1px solid var(--border)', background: open ? 'var(--surface-2)' : 'var(--surface)', cursor: 'pointer', color: 'var(--text-2)', width: 34, height: 34, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        <Icon name="notifications" size={20} />
        {items.length > 0 && <span style={{ position: 'absolute', top: 7, right: 8, width: 7, height: 7, borderRadius: '50%', background: 'var(--danger)', border: '1.5px solid var(--surface)' }} />}
      </button>
      {open && (
        <div style={{ position: 'absolute', top: '100%', right: 0, marginTop: 6, width: 320, maxWidth: '80vw', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, boxShadow: 'var(--shadow-md)', zIndex: 60, overflow: 'hidden', maxHeight: 420, overflowY: 'auto' }}>
          <div style={{ padding: '12px 14px', borderBottom: '1px solid var(--border)', fontWeight: 600, fontSize: 13.5 }}>Notifications</div>
          {items.length === 0 && <div style={{ padding: 16, fontSize: 13, color: 'var(--text-3)', textAlign: 'center' }}>Nothing yet.</div>}
          {items.map((a) => {
            const tone = st(a.tone);
            return (
              <div key={a.id} style={{ display: 'flex', gap: 11, padding: '10px 14px', borderBottom: '1px solid var(--border)' }}>
                <div style={{ width: 28, height: 28, flex: '0 0 auto', borderRadius: '50%', background: tone.bg, color: tone.fg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Icon name={a.icon} size={16} color={tone.fg} />
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 12.5, lineHeight: 1.4 }}><strong style={{ fontWeight: 600 }}>{a.actor}</strong> {a.action}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 1 }}>{a.created_at}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
